import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertStatus'
})

export class ConvertStatusPipe implements PipeTransform {

  transform(value: boolean): string {
    return value  ? 'Active'  : 'Inactive';
  }
}
